import { useQuery } from '@apollo/client/react';

import SWITCHES_Q from '../gql/index.gql';

/** Fetch one switch by filtering the switches connection on id. */
export const useSwitch = (switchId: string | undefined) => {
  const { data, ...rest } = useQuery(SWITCHES_Q, {
    variables: {
      first: 1,
      queryList: [{ key: 'id', value: { value: switchId } }],
    },
    skip: !switchId,
  });

  return { switch: data?.switches?.edges[0]?.node ?? null, ...rest };
};
